module.exports = __webpack_public_path__ + "static/media/win.1c65c279.png";